import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import About from "../components/About"

import Projects from "../components/Projects"
import Process from "../components/Process"
import ConsultationForm from "../components/ConsultationForm"
import Footer from "../components/Footer"

function Home(){

return(

<>
<Navbar/>
<Hero/>
<About/>
<Projects/>
<Process />
<ConsultationForm/>
<Footer/>
</>

)

}

export default Home